import { useAuthStore } from "@store/auth.store";
import type { SidekickModuleId } from "@shared/access-control/sidekick-modules";

export function useHasModule(moduleId: SidekickModuleId | undefined): boolean {
  const modules = useAuthStore((state) => state.user.modules);
  if (!moduleId) return true;
  // Sessions persisted before `modules` existed on User are rehydrated
  // without it (zustand's persist merge replaces `user` wholesale rather
  // than deep-merging), so this can be undefined until a fresh profile
  // fetch backfills it.
  return (modules ?? []).includes(moduleId);
}
